// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"7558ae7c47148e2a1971","883":"2c58438984893d75e8d6"}[chunkId] + ".js";
};